import BaseStore from 'stores/base'

export default class OverbillStore extends BaseStore {
  constructor(api, options) {
    super(api)
    this.api = api
    this.options = options
  }

  getOverbillApproval(key) {
    return this.getRequest(this.CRUD, async () => this.service.getOverbillApproval(key))
  }

  approveOverbill(piId) {
    return this.request(this.CRUD, async () => this.service.approveOverbill(piId))
  }

  rejectOverbill(piId, payload) {
    return this.request(this.CRUD, async () => this.service.rejectOverbill(piId, payload))
  }
}
